// import React, { useState, useEffect } from 'react';
// import PropTypes from 'prop-types';
// import Plot from 'react-plotly.js';
// import { ManRadioButtonGroup, ManRadioButton, ManText } from '@craft-design-system/core-components-react';
// import { Popover, OverlayTrigger } from 'react-bootstrap';
// import { CustomTextDisplay } from '../AI';
// import { useFilterContext } from '../FilterContext';
// import useGraphRadio from '../../utils/useGraphRadio';
// import { useResetContext } from '../ResetContext';
// import useSegmentedChartQuery from '../../utils/useSegmentedChartQuery';
// import AverageDisplay from '../ride_analysis_kpi/Average_value';
// import DownloadButtonComponent from '../DownloadButtonComponent';
// import Shimmer_graph from '../shimmer_graph';
// import ifav from './ifav.png';
// import Zoom from '../Zoom';
// import SegmentedControl from '../ride_analysis_kpi/SegmentedControl';



// const Battery_temp_normal = ({ value }) => {
//   const [Battery_temp_normal, set_Battery_temp_normal] = useState(null);
//   const [downloadData, setDownloadData] = useState([]);
//   const radio_query = useGraphRadio();
//   const [radio_buttons_test, set_Radio_values] = useState(null);
//   const { filterdata } = useFilterContext();
//   const { startDate, endDate } = filterdata || {};
//   const [isLoading, setIsLoading] = useState(false);
//   const [chartType, setChartType] = useState("Bar");
//   const [isInitialLoad, setIsInitialLoad] = useState(true);
//   const [showMonthlyText, setShowMonthlyText] = useState(value.battery_temp_during_normal_charging[1]['battery_normal_charging']);
//   const [avg_value, setavg_value] = useState(value.battery_temp_during_normal_charging[2]['average']);
//   const { resetdata } = useResetContext();
//   const { fetchSegmentedChart } = useSegmentedChartQuery();

//   const isBarOnly = Battery_temp_normal?.data?.every(trace => trace.type === 'bar');

//   const popover = (
//     <Popover id="popover-basic">
//       <Popover.Body>
//         <strong>Definition:</strong><br />
//         The battery temperature (system) during normal charging cycle is displayed using minimum, average and maximum values.<br /><br />
  
//         <strong>Telematic raw data for this KPI:</strong><br />
//         TBM3: <br />
//         • batterytemperature<br />
//         CM4: 
//         • batterytemperature<br /><br />
  
//         <strong>Time series data:</strong><br />
//         If multiple vehicles are selected, average values are displayed. Days without data are not taken into account for the calculation.<br /><br />
  
//         <strong>Histogram:</strong><br />
//         Each bar represents the number of cycles that fall within a certain range (bin) of <strong>average battery system temperature values during normal charging.</strong><br />
//         All average battery system temperature values during normal charging since start of data acquisition for the selected vehicle(s) are visualized per default.<br /><br />
  
//         <strong>Boxplot:</strong><br />
//         The boxplot shows the <strong>distribution of average battery system temperature values during normal charging</strong> for the selected vehicle(s) since start of data acquisition.<br />
//         If multiple vehicles are selected, the boxplot reflects the combined distribution of all their values.<br />
//         • The <strong>box</strong> represents the middle 50% of values (from the 25th percentile ("q1") to the 75th percentile ("q3")).<br />
//         • The line <strong>inside the box</strong> shows the median (50th percentile).<br />
//         • The whiskers extend to show the range of typical values ("min" and "max") and visualize <strong>the spread of the data</strong> beyond the central box.
//       </Popover.Body>
//     </Popover>
//   );
  

//   const handleSelectChange1 = (event) => {
//     set_Radio_values((prevValues) => ({
//       ...prevValues,
//       [event.detail.name]: event.detail.value,
//     }));
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       setIsLoading(true);
//       try {
//         const data = await fetchSegmentedChart({
//           vinShort: value.vin_short,
//           chartType,
//           category: resetdata,
//           columnname: 'Battery temp normal',
//         });

//         if (chartType === 'Bar') {
//           set_Battery_temp_normal(JSON.parse(data[0]));
//           setDownloadData(JSON.parse(data[3]));
//         } else {
//           set_Battery_temp_normal(JSON.parse(data[0]));
//           setDownloadData(JSON.parse(data[1]));
//         }
//       } catch (error) {
//         console.error('Error fetching chart data:', error);
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     if (!isInitialLoad && chartType && value?.vin_short) {
//       fetchData();
//     } else {
//       setIsInitialLoad(false);
//     }
//   }, [chartType]);

//   useEffect(() => {
//     if (radio_buttons_test) {
//       setIsLoading(true);

//       //console.log(value.vin_short)
//       radio_query({vins_short:[value.vin_short],radio_value:radio_buttons_test,columnname:'Battery temp normal',startDate:startDate,endDate:endDate}).then(data => {
//         set_Battery_temp_normal(JSON.parse(data['jsonData'][0]));
//         setShowMonthlyText(data['jsonData'][1]['battery_normal_charging']);
//         setavg_value(data['jsonData'][2]['average']);
//         setDownloadData(JSON.parse(data['jsonData'][3]));
//         setIsLoading(false);
//       });
//     }
//   }, [radio_buttons_test, chartType]);

//   useEffect(() => {
//     try {
//       set_Battery_temp_normal(JSON.parse(value.battery_temp_during_normal_charging[0]));
//       if (value.battery_temp_during_normal_charging[3]) {
//         setDownloadData(JSON.parse(value.battery_temp_during_normal_charging[3]));
//       }
//     } catch (error) {
//       console.error("Error parsing JSON", error);
//     }
//   }, [value]);

//   return (
    
//     <div style={{ padding: '16px' }}>
//     {/* Title + Info */}
//     <div style={{
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       marginBottom: '8px',
//       gap: '8px'
//     }}>
//       <div style={{
//         flex: 1,
//         textAlign: 'center',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         marginLeft: '80px'
//       }}>
//         <ManText
//           className="card-title-text"
//           variant="component-l"
//           as="span"
//           size="l"
//           style={{ lineHeight: 'normal' }}
//         >
//          Battery temperature (system) during normal charging
//         </ManText>
//       </div>
//       <div style={{
//         flexShrink: 0,
//         display: 'flex',
//         alignItems: 'center',
//         height: '100%',
//         flexDirection: "row-reverse"
//       }}>
//         {/* <PopoverComponent
//           id="charging_time"
//           content={tooltipContent}
//         /> */}
//         <OverlayTrigger trigger="hover" placement="left" overlay={popover}>
//           <img className="man-logovv1" src={ifav} alt="info" />
//         </OverlayTrigger>
//         <Zoom
//           chartData={Battery_temp_normal?.data}
//           chartLayout={Battery_temp_normal?.layout}
//           chartTitle="Battery temperature (system) during normal charging"
//         />
//         <DownloadButtonComponent
//           data={downloadData}
//           fileName={`battery_temp_normal_${chartType.toLowerCase()}_${radio_buttons_test?.['Battery Temperature Normal Charge']?.toLowerCase() || 'daily'}.xlsx`}
//         />
//       </div>
//     </div>

//       <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
//         <div style={{ flexShrink: 0 }}>
//           <AverageDisplay averages={avg_value} unit="°C" />
//         </div>
            
//         <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
//         <ManRadioButtonGroup
//           name="Battery Temperature Normal Charge"
//           invalid="false"
//           onManChange={handleSelectChange1}
//         >
//           <ManRadioButton name="Battery Temperature Normal Charge" label="Daily" value="Daily" checked />
//           <ManRadioButton name="Battery Temperature Normal Charge" label="Monthly" value="Monthly" />
//           <ManRadioButton name="Battery Temperature Normal Charge" label="Yearly" value="Yearly" />
//         </ManRadioButtonGroup>
//         </div>
//         <div style={{ marginLeft: 'auto' }}>
//           <SegmentedControl
//             selected={chartType}
//             onChange={(type) => setChartType(type)}
//             options={["Bar", "Histogram", "Boxplot"]}
//           />
//         </div>
//       </div>

//       <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
//         {isLoading ? (
//           <Shimmer_graph />
//         ) : (
//           Battery_temp_normal && (
//             <>
//               <Plot
//                 data={Battery_temp_normal.data}
//                 layout={{
//                   ...Battery_temp_normal.layout,
//                   autosize: true,
//                   responsive: true,
//                   margin: { t: 10, r: 10, l: 10, b: 160 },
//                   xaxis: {
//                     ...Battery_temp_normal.layout?.xaxis,
//                     ...(isBarOnly
//                       ? {
//                           rangeslider: { visible: true, thickness: 0.05 },
//                           range: [
//                             Battery_temp_normal.data[0]?.x?.slice(-14)[0],
//                             Battery_temp_normal.data[0]?.x?.slice(-1)[0]
//                           ],
//                         }
//                       : {
//                           rangeslider: { visible: false },
//                         }),
//                   },
//                 }}
//                 useResizeHandler={true}
//               />
//               {/* <CustomTextDisplay
//                 title="AI | Automotive Intelligence"
//                 value={showMonthlyText}
//                 isValueStyled
//               /> */}
//             </>
//           )
//         )}
//       </div>
//     </div>
//   );
// };

// Battery_temp_normal.propTypes = {
//   value: PropTypes.shape({
//     vin_short: PropTypes.string.isRequired,
//     battery_temp_during_normal_charging: PropTypes.array.isRequired,
//   }).isRequired,
// };

// export default Battery_temp_normal;


import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Plot from 'react-plotly.js';
import { ManRadioButtonGroup, ManRadioButton, ManText } from '@craft-design-system/core-components-react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import { useFilterContext } from '../FilterContext';
import useGraphRadio from '../../utils/useGraphRadio';
import { useResetContext } from '../ResetContext';
import useSegmentedChartQuery from '../../utils/useSegmentedChartQuery';
import AverageDisplay from '../ride_analysis_kpi/Average_value';
import DownloadButtonComponent from '../DownloadButtonComponent';
import Shimmer_graph from '../shimmer_graph';
import ifav from './ifav.png';
import Zoom from '../Zoom';
import SegmentedControl from '../ride_analysis_kpi/SegmentedControl';
import AIToggleButton from '../AIToggleButton';

const Battery_temp_normal = ({ value }) => {
  // 🔥 Main state variables - matching fast charge pattern
  const [chartData, setChartData] = useState(null);
  const [downloadData, setDownloadData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [chartType, setChartType] = useState("Bar");
  const [avgValue, setAvgValue] = useState(null);
  const [radioButtons, setRadioButtons] = useState(null); // 🔥 Start with null instead of default object
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // 🔥 AI-related state
  const [cleanedAIData, setCleanedAIData] = useState([]);

  // 🔥 Context and hooks
  const { filterdata } = useFilterContext();
  const { startDate, endDate } = filterdata || {};
  const { resetdata } = useResetContext();
  const radio_query = useGraphRadio();
  const { fetchSegmentedChart } = useSegmentedChartQuery();

  // 🔥 Chart type detection
  const isBarOnly = chartData?.data?.every(trace => trace.type === 'bar');

  // 🔥 Helper function to extract average value from object
  const extractAverageValue = (avgData) => {
    if (!avgData) return null;
    
    // If it's already a primitive value (string/number), return it
    if (typeof avgData !== 'object') return avgData;
    
    // If it's an object with an 'average' property, extract it
    if (avgData.average !== undefined) return avgData.average;
    
    // If it's an object but doesn't have 'average', try to find a numeric value
    const values = Object.values(avgData);
    const numericValue = values.find(val => typeof val === 'number' || !isNaN(val));
    
    return numericValue || null;
  };

  const popover = (
    <Popover id="popover-basic">
      <Popover.Body>
        <strong>Definition:</strong><br />
        The battery temperature (system) during normal charging cycle is displayed using minimum, average and maximum values.<br /><br />
  
        <strong>Telematic raw data for this KPI:</strong><br />
        TBM3: <br />
        • batterytemperature<br />
        CM4: 
        • batterytemperature<br /><br />
  
        <strong>Time series data:</strong><br />
        If multiple vehicles are selected, average values are displayed. Days without data are not taken into account for the calculation.<br /><br />
  
        <strong>Histogram:</strong><br />
        Each bar represents the number of cycles that fall within a certain range (bin) of <strong>average battery system temperature values during normal charging.</strong><br />
        All average battery system temperature values during normal charging since start of data acquisition for the selected vehicle(s) are visualized per default.<br /><br />
  
        <strong>Boxplot:</strong><br />
        The boxplot shows the <strong>distribution of average battery system temperature values during normal charging</strong> for the selected vehicle(s) since start of data acquisition.<br />
        If multiple vehicles are selected, the boxplot reflects the combined distribution of all their values.<br />
        • The <strong>box</strong> represents the middle 50% of values (from the 25th percentile ("q1") to the 75th percentile ("q3")).<br />
        • The line <strong>inside the box</strong> shows the median (50th percentile).<br />
        • The whiskers extend to show the range of typical values ("min" and "max") and visualize <strong>the spread of the data</strong> beyond the central box.
      </Popover.Body>
    </Popover>
  );

  // 🔥 Radio button handler - exactly like fast charge pattern
  const handleSelectChange1 = (event) => {
    console.log('📻 Radio button changed:', event.detail.name, event.detail.value);
    console.log('📻 Current resetdata:', resetdata);
    
    setRadioButtons({
      ...radioButtons,
      [event.detail.name]: event.detail.value,
    });
  };

  // 🔥 Clean download data for AI insights
  useEffect(() => {
    if (downloadData && downloadData.length > 0) {
      const cleanData = downloadData.filter(item => 
        item && typeof item === 'object' && Object.keys(item).length > 0
      );
      setCleanedAIData(cleanData);
    }
  }, [downloadData]);

  // 🔥 Fetch data when chart type changes - like fast charge
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        console.log('📊 Fetching segmented chart with category:', resetdata);
        
        const data = await fetchSegmentedChart({
          vinShort: value.vin_short,
          chartType,
          category: resetdata,
          columnname: 'Battery temp normal',
        });

        // 🔥 Handle object format response from backend
        if (data && typeof data === 'object') {
          if (data.chart) {
            setChartData(JSON.parse(data.chart));
          }
          if (data.downloadData) {
            setDownloadData(data.downloadData);
          }
          if (data.average) {
            // 🔥 Extract the actual average value from the object
            setAvgValue(extractAverageValue(data.average));
          }
        } else if (Array.isArray(data)) {
          // Legacy array format fallback
          if (chartType === 'Bar') {
            setChartData(JSON.parse(data[0]));
            if (data[3]) setDownloadData(JSON.parse(data[3]));
          } else {
            setChartData(JSON.parse(data[0]));
            if (data[1]) setDownloadData(JSON.parse(data[1]));
          }
        }
      } catch (error) {
        console.error('Error fetching chart data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    if (!isInitialLoad && chartType && value?.vin_short) {
      fetchData();
    } else {
      setIsInitialLoad(false);
    }
  }, [chartType, resetdata]);

  // 🔥 Handle radio button changes - exactly like fast charge
  useEffect(() => {
    if (!radioButtons) return;

    console.log('📻 Radio fetch triggered with:', radioButtons);
    console.log('📻 Current category (resetdata):', resetdata);

    setIsLoading(true);

    // 🔥 Enhanced params to include category properly
    const params = {
      vins_short: [value.vin_short],
      radio_value: radioButtons,
      columnname: 'Battery temp normal',
      startDate,
      endDate,
      filterdata: {
        ...filterdata,
        category: resetdata,
        resetdata: resetdata
      },
      resetdata: resetdata,
      category: resetdata
    };

    console.log('📻 Sending radio query with params:', params);

    radio_query(params)
      .then(res => {
        console.log('📻 Radio query response:', res);

        // 🔥 Support BOTH response formats
        const payload = res.jsonData ?? res;

        // Handle object format response
        if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
          if (payload.chart) {
            setChartData(JSON.parse(payload.chart));
          }
          if (payload.downloadData) {
            setDownloadData(payload.downloadData);
          }
          if (payload.average) {
            setAvgValue(extractAverageValue(payload.average));
          }
        } else if (Array.isArray(payload)) {
          // Legacy array format fallback
          setChartData(JSON.parse(payload[0]));
          if (payload[2]?.['average']) {
            setAvgValue(extractAverageValue(payload[2]['average']));
          }
          if (payload[3]) {
            setDownloadData(JSON.parse(payload[3]));
          }
        }
      })
      .catch(err => {
        console.error("❌ Radio fetch failed:", err);
      })
      .finally(() => setIsLoading(false));

  }, [radioButtons, resetdata]);

  // 🔥 Initialize data from props
  useEffect(() => {
    if (!value?.battery_temp_during_normal_charging) return;

    console.log('🔍 Initial load, value prop:', value);

    try {
      const batteryData = value.battery_temp_during_normal_charging;
      
      if (Array.isArray(batteryData)) {
        // Legacy array format
        if (batteryData[0]) {
          setChartData(JSON.parse(batteryData[0]));
        }
        if (batteryData[3]) {
          setDownloadData(JSON.parse(batteryData[3]));
        }
        if (batteryData[2]?.['average']) {
          // 🔥 Extract the actual average value
          setAvgValue(extractAverageValue(batteryData[2]['average']));
        }
      } else if (typeof batteryData === 'object') {
        // 🔥 New object format
        if (batteryData.chart) {
          setChartData(JSON.parse(batteryData.chart));
        }
        if (batteryData.downloadData) {
          setDownloadData(batteryData.downloadData);
        }
        if (batteryData.average) {
          // 🔥 Extract the actual average value from the object
          setAvgValue(extractAverageValue(batteryData.average));
        }
      }
    } catch (error) {
      console.error("Error parsing battery temperature data:", error);
    }
  }, [value]);

  // 🔥 Monitor resetdata changes - like fast charge
  useEffect(() => {
    console.log('🔄 resetdata changed to:', resetdata);
    
    // If we have radio buttons selected and resetdata changes, refetch
    if (radioButtons && resetdata) {
      console.log('🔄 Refetching due to category change');
      // Trigger refetch by updating radioButtons state slightly
      setRadioButtons({...radioButtons});
    }
  }, [resetdata]);

  // 🔥 Early return if no data
  if (!value?.vin_short) {
    return (
      <div style={{ padding: '16px' }}>
        <div style={{ textAlign: 'center', color: '#666' }}>
          No vehicle data available
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: 16 }}>
      {/* Debug info - remove in production */}
      {/* <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px' }}>
        Debug: Category = {resetdata || 'None'}, Radio = {JSON.stringify(radioButtons)}
      </div> */}

      {/* Header Section */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8, alignItems: 'center' }}>
        <div style={{ flex: 1, textAlign: 'center', marginLeft: '80px' }}>
          <ManText
            className="card-title-text"
            variant="component-l"
            as="span"
            size="l"
            style={{ lineHeight: 'normal' }}
          >
            Battery temperature (system) during normal charging
          </ManText>
        </div>

        <div style={{ 
          display: 'flex', 
          gap: 10, 
          flexDirection: "row-reverse",
          alignItems: 'center' // 🔥 Added to align all icons in the center
        }}>
          <OverlayTrigger trigger="hover" placement="left" overlay={popover}>
            <img 
              className="man-logovv1" 
              src={ifav} 
              alt="info" 
              style={{ 
                cursor: 'pointer',
                alignSelf: 'center' // 🔥 Ensures info icon aligns with other icons
              }} 
            />
          </OverlayTrigger>

          <Zoom
            chartData={chartData?.data}
            chartLayout={chartData?.layout}
            chartTitle="Battery temperature (system) during normal charging"
          />

          <DownloadButtonComponent
            data={downloadData}
            fileName={`battery_temp_normal_${chartType.toLowerCase()}_${radioButtons?.['Battery Temperature Normal Charge']?.toLowerCase() || 'daily'}.xlsx`}
          />
        </div>
      </div>

      {/* Controls Section */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
        {chartType === 'Bar'
          ? (
            <div style={{ flexShrink: 0 }}>
              {/* 🔥 Use extracted average value */}
              <AverageDisplay averages={avgValue} unit="°C" />
            </div>
          )
          : <div style={{ width: 150 }} />
        }

        {chartType === 'Bar' && (
          <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
            <ManRadioButtonGroup 
              name="Battery Temperature Normal Charge" 
              invalid="false"
              onManChange={handleSelectChange1}
            >
              <ManRadioButton name="Battery Temperature Normal Charge" label="Daily" value="Daily" checked />
              <ManRadioButton name="Battery Temperature Normal Charge" label="Monthly" value="Monthly" />
              <ManRadioButton name="Battery Temperature Normal Charge" label="Yearly" value="Yearly" />
            </ManRadioButtonGroup>
          </div>
        )}

        <div style={{ marginLeft: 'auto' }}>
          <SegmentedControl
            selected={chartType}
            onChange={setChartType}
            options={["Bar", "Histogram", "Boxplot"]}
          />
        </div>
      </div>

      {/* Chart Section */}
      {/* Chart Section */}
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
        {isLoading ? (
          <Shimmer_graph />
        ) : (
          chartData && (
            <>
              <Plot
                data={chartData.data}
                layout={{
                  ...chartData.layout,
                  autosize: true,
                  responsive: true,
                  margin: chartType === 'Bar' 
                    ? { t: 10, r: 10, l: 10, b: 160 } // 🔥 Reduced margin since button is moved outside
                    : { t: 10, r: 10, l: 10, b: 180 },
                  xaxis: {
                    ...chartData.layout?.xaxis,
                    ...(isBarOnly
                      ? {
                          rangeslider: { visible: true, thickness: 0.05 },
                          range: [
                            chartData.data[0]?.x?.slice(-14)[0],
                            chartData.data[0]?.x?.slice(-1)[0]
                          ],
                        }
                      : {
                          rangeslider: { visible: false },
                        }),
                  },
                }}
                useResizeHandler={true}
                style={{
                  width: '100%',
                  height: chartType === 'Bar' ? '450px' : '400px'
                }}
              />

              {/* 🔥 AI Toggle Button - Bottom left corner */}
              {chartType === 'Bar' && cleanedAIData?.length > 0 && (
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'flex-start', // 🔥 Left alignment
                  marginTop: '16px' // 🔥 Space from chart
                }}>
                  <AIToggleButton
                    downloadData={cleanedAIData}
                    radioButtonState={radioButtons}
                    kpiName="Battery Temperature Normal Charge"
                    chartType={chartType}
                    vinShort={value.vin_short}
                    title="AI | Automotive Intelligence - Normal Charging Battery Temperature Analysis"
                  />
                </div>
              )}
            </>
          )
        )}
      </div>
    </div>
  );
};

Battery_temp_normal.propTypes = {
  value: PropTypes.shape({
    vin_short: PropTypes.string.isRequired,
    battery_temp_during_normal_charging: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object
    ]),
  }).isRequired,
};

export default Battery_temp_normal;